import React, { useState } from 'react';

import { Select } from '@aline/common';
import type { DocumentStatusFilterType } from 'src/components';
import { DocumentStatusFilter, UploadFilesPicker, UploadIconButton } from 'src/components';
import { FileStackDomContainer } from 'src/helpers';

import { statusToDocumentVariant } from './RepositoryNewButton';

interface RepositoryUploadButtonProps {
  documentStatusFilter: DocumentStatusFilterType;
  disabled?: boolean;
  onPickerOpenChange?: (open: boolean) => void;
  repositoryId?: UUID;
}

export function RepositoryUploadButton({
  disabled = false,
  documentStatusFilter,
  onPickerOpenChange,
  repositoryId,
}: RepositoryUploadButtonProps): JSX.Element {
  const [filePickerOpen, setFilePickerOpen] = useState(false);
  const setPickerOpen = (open: boolean): void => {
    setFilePickerOpen(open);
    onPickerOpenChange?.(open);
  };

  return (
    <>
      <UploadIconButton
        data-cy={Select.repository.uploadDocumentButton}
        disabled={disabled}
        tooltip="Upload"
        onClick={() => setPickerOpen(true)}
      />
      <UploadFilesPicker
        domContainer={FileStackDomContainer.Repository}
        open={filePickerOpen}
        pickerDataCy={Select.repository.filePicker.container}
        pickerOpts={{
          afterUploadDone: () => setPickerOpen(false),
          onClose: () => setPickerOpen(false),
          props: {
            documentVariant: statusToDocumentVariant(documentStatusFilter),
            isSigned: documentStatusFilter === DocumentStatusFilter.Signed,
          },
          reportId: repositoryId,
        }}
      />
    </>
  );
}
